import axios from 'axios';
import authProvider from 'src/services/authProvider';

const instance = axios.create();

instance.interceptors.request.use((config) => authProvider
  .getIdToken().then((tokenResponse) => {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${tokenResponse.idToken.rawIdToken}`;
    return Promise.resolve(config);
  }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error(error);
  }), (error) => Promise.reject(error));

export default instance;
